import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Lightbox from './Lightbox';
import ImageCarousel from './ImageCarousel';
import useLightbox from '../hooks/useLightbox';

const ENTERING_IMAGES = [
  "https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/rtrxmpdf_Barefoot1705.jpg",
  "https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/eo2vxgz3_Barefoot3117.jpg"
];

const MAP_IMAGES = [
  "https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/r4q781v0_carte%202.jpg",
  "https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/veeuf8vb_carte.jpg",
  "https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/8947tle3_Carte%203.jpg"
];

const MAP_SCALES = [1, 1, 0.6];

const EnteringImagesBanner = () => {
  const lightbox = useLightbox(ENTERING_IMAGES.length);

  return (
    <>
      <div 
        className="w-full py-4 md:py-8 bg-white relative"
        style={{ isolation: 'isolate' }}
      >
        <div className="absolute inset-0 bg-white z-0" />
        <div className="container mx-auto px-4 md:px-12 max-w-[1400px] relative z-10">
          <div className="grid grid-cols-2 gap-3 md:gap-6">
            {ENTERING_IMAGES.map((src, index) => (
              <div key={src} className="relative overflow-hidden bg-white">
                <div 
                  className="aspect-[2/5] md:aspect-[3/4] cursor-pointer"
                  onClick={() => lightbox.open(index)}
                >
                  <img
                    src={src}
                    alt={index === 0 ? 'Cabo Verde village' : 'Cabo Verde landscape'}
                    className={`w-full h-full object-cover ${index === 1 ? 'object-left' : ''}`}
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Lightbox
        isOpen={lightbox.isOpen}
        onClose={lightbox.close}
        image={ENTERING_IMAGES[lightbox.currentIndex]}
        onPrev={lightbox.prev}
        onNext={lightbox.next}
        hasPrev={true}
        hasNext={true}
      />
    </>
  );
};

const Welcome = () => {
  const { t } = useLanguage();

  return (
    <section 
      id="welcome" 
      className="py-10 md:py-14 pb-4 md:pb-6 bg-white" 
      data-testid="welcome-section"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-[360px] md:max-w-[750px]">
        <div className="text-center">
          <p 
            className="text-lg md:text-xl lg:text-2xl text-black leading-relaxed tracking-wide"
            style={{ 
              fontFamily: '"IvyPresto Text", serif', 
              fontWeight: 300,
              textWrap: 'balance'
            }}
          >
            {t('welcome.description')}
          </p>
        </div>
      </div>

      {/* Entering Images Banner */}
      <div className="mt-10 md:mt-14">
        <EnteringImagesBanner />
      </div>

      {/* Destination for Explorers Section */}
      <div 
        id="destination"
        className="container mx-auto px-4 md:px-12 max-w-[1400px] scroll-mt-24 mt-10 md:mt-14"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <h3 className="font-serif text-3xl md:text-4xl text-black mb-6 text-center">
              {t('welcome.explorerTitle')}
            </h3>
            <p className="text-base md:text-lg text-black/70 leading-relaxed font-light text-center">
              {t('welcome.explorerDescription')}
            </p>
          </div>

          {/* Maps Carousel */}
          <div className="order-1 lg:order-2">
            <div className="w-full mx-auto">
              <ImageCarousel 
                images={MAP_IMAGES}
                alt="Cape Verde Maps"
                className="aspect-[4/3]"
                objectFit="contain"
                showArrows={true}
                scales={MAP_SCALES}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
